/* eslint-disable import/no-named-as-default-member */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../redux/actions'
import { Link, useParams, useHistory } from 'react-router-dom'
import BackButton from 'components/Button/BackButton'
// components
import {
  Button,
  Collapse,
  IconButton,
  Link as LinkUI,
  Skeleton,
} from '@chakra-ui/react'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import SpinnerLoading from 'components/Loading/SpinnerLoading'
import PlaceHolderLogo from '../../assets/img/eiotlogo.png'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import DashboardMonitorComponentSlide from './Components/DashboardMonitorComponentSlide'
import UserRoles from '../../config/UserRoles'

export default function DashboardGroup({ sidebarStatus, setIsShowSidebar }) {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(true)
  const [currentStation, setcurrentStation] = useState()
  const [currentGroup, setcurrentGroup] = useState()
  const [isFetchNewOne, setisFetchNewOne] = useState(true)
  const [isStationInfoShow, setIsStationInfoShow] = useState(false)
  const [priority, setPriority] = useState()
  const [priGauge, setPriGauge] = useState()
  const dispatch = useDispatch()
  const params = useParams()
  const allStations = useSelector((state) => state.station)
  const me = useSelector((state) => state.me)
  const history = useHistory()
  const [activeTab, setActiveTab] = useState()
  const [Sg, setSG] = useState([])
  const vasibleTabs = 3
  const [startIndex, setStartIndex] = useState(0)
  const handlePrev = () => {
    setStartIndex(startIndex - 1)
  }
  const handleNext = () => setStartIndex(startIndex + 1)
  // console.log('value', value)

  useEffect(() => {
    if (isFetchNewOne === true) {
      dispatch(actions.stationAll())
      //FIXME: Uncommen to Enable Auto Refresh
      setisFetchNewOne(false)
    }
    return () => {}
  }, [isFetchNewOne])

  useEffect(() => {
    if (allStations) {
      const tempcurrentStatus = _.find(
        allStations.arr,
        (station) => station._id === params.stationId
      )
      setcurrentStation(tempcurrentStatus)
    }

    return () => {}
  }, [params, allStations])

  // ดึงข้อมูลสถานีทั้งหมดมา เพราะว่า จะต้องเอาไปโชว์ใน Sidebar
  // จากนั้นค่อยหาเอาตัวหนึ่งที่ไอดีมันถูก
  useEffect(() => {
    const og = []

    if (currentStation) {
      const tempGroup = _.find(
        currentStation?.groups,
        (group) => group?._id === params?.groupId
      )
      setcurrentGroup(tempGroup)
      setActiveTab(tempGroup?.groupName)

      const tempPriority = _.find(
        currentStation?.priority,
        (prior) => prior?.role === me?.role
      )

      _.map(tempPriority?.gauge, (gaugeS) => {
        const GG = _.filter(currentStation?.gauges, (gg, ind) => {
          if (gg._id === gaugeS) {
            // return gg
            og.push(gg)
          }
        })
        //console.log('GG', GG)
        return GG
      })
      setPriority(tempPriority)
      setPriGauge(og)
    }
    return () => {}
  }, [currentStation, me])

  useEffect(() => {
    if (isFetchNewOne === false) {
      setTimeout(() => {
        setisFetchNewOne(true)
      }, 10000)
    }
    return () => {}
  }, [isFetchNewOne])

  useEffect(() => {
    let orderedGauge = _.orderBy(priGauge, 'orderLevel', 'asc')
    //console.log('charts', GroupChart, priGauge)
    const selectG = []
    const searchGauge = () =>
      _.map(currentGroup?.gauge, (gaugeS) => {
        const GG = _.filter(priGauge, (gg, ind) => {
          if (gg._id === gaugeS) {
            // return gg
            selectG.push(gg)
          }
        })
        //console.log('GG', GG)
        return GG
      })

    searchGauge()
    setSG(selectG)
    return () => {}
  }, [currentGroup, priGauge])

  const handleEditUserFavorite = (data) => {
    const checkFavorite = _.find(
      me?.favorite?.gauge,
      (gauges) => gauges === data?._id
    )
    const arrayData = me?.favorite?.gauge
    if (!_.isEmpty(checkFavorite)) {
      _.remove(arrayData, (e) => e === data?._id)
      const dataSubmit = {
        ...me,
        favorite: {
          gauge: arrayData,
          chart: me?.favorite?.chart,
        },
      }
      dispatch(actions.userPut(me?._id, dataSubmit))
      dispatch(actions.meGet({}))
      setisFetchNewOne(true)
    } else {
      arrayData.push(data?._id)
      const dataSubmit = {
        ...me,
        favorite: {
          gauge: arrayData,
          chart: me?.favorite?.chart,
        },
      }
      dispatch(actions.userPut(me?._id, dataSubmit))
      dispatch(actions.meGet({}))
      setisFetchNewOne(true)
    }
  }
  // console.log('currentGroup', currentGroup)

  const findGroup = () => {
    let groupList = [] // กลุ่มที่อนุญาติให้เห็น
    if (me?.role === UserRoles.ROLES.USER) {
      groupList = _.filter(
        currentStation?.groups,
        (g) => g.role === UserRoles.ROLES.USER
      )
    } else if (me?.role === UserRoles.ROLES.ADMIN) {
      groupList = _.filter(
        currentStation?.groups,
        (g) =>
          g.role === UserRoles.ROLES.ADMIN || g.role === UserRoles.ROLES.USER
      )
    } else if (me?.role === UserRoles.ROLES.MANAGER) {
      groupList = _.filter(
        currentStation?.groups,
        (g) =>
          g.role === UserRoles.ROLES.USER ||
          g.role === UserRoles.ROLES.ADMIN ||
          g.role === UserRoles.ROLES.MANAGER
      )
    } else if (me?.role === UserRoles.ROLES.SUPER_USER) {
      groupList = currentStation?.groups
    }

    return _.map(groupList, (group, index) => {
      return (
        <Link
          to={'/dashboards/boardgroup/' + currentStation._id + '/' + group._id}
        >
          <Button
            key={index}
            // colorScheme="gray"
            className={`flex-1 text-center text-lg font-medium border-b-4 transition-all duration-300  ${
              activeTab === group.groupName
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500'
            }`}
            onClick={() => setActiveTab(group.groupName)}
          >
            {group.groupName}
          </Button>
        </Link>
      )
    })
  }

  if (!isLoading) {
    return <SpinnerLoading />
  }

  return (
    <div className="relative flex flex-col min-w-0 break-words bg-gray-100 w-full mb-6 shadow-lg rounded">
      <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div className="flex flex-wrap items-center">
          <div className="relative w-full max-w-full flex-grow flex-1">
            <h6 className="uppercase text-gray-500 mb-1 text-xs font-semibold font-sans">
              {t('dashboard.dashboardMonitor')}
            </h6>
            <h2 className="text-gray-800 text-2xl font-bold font-sans">
              {t('dashboard.dashboard')} {currentStation?.name}
            </h2>
          </div>
        </div>
        <Button>
          <BackButton />
        </Button>
      </div>
      <div className="flex flex-auto justify-center gap-1">
        <IconButton
          icon={<ChevronLeft />}
          isDisabled={startIndex === 0}
          onClick={handlePrev}
        />
        {findGroup()}
        <IconButton
          icon={<ChevronRight />}
          isDisabled={
            startIndex + vasibleTabs <= currentGroup?.length - vasibleTabs
          }
          onClick={handleNext}
        />
      </div>

      <div className="flex justify-between p-4">
        <h2 className="text-gray-800 text-xl px-10 font-bold font-sans">
          กลุ่ม {currentGroup?.groupName}
        </h2>
      </div>

      {!currentGroup && (
        <div className="px-4">
          <Skeleton height="8" />
        </div>
      )}
      {_.isEmpty(priGauge) && (
        <div className="px-4">
          <Skeleton height="8" />
        </div>
      )}

      <div className="p-4 w-full font-sans">
        <Collapse in={isStationInfoShow} animateOpacity>
          <div className="bg-gray-200 border rounded-md p-2">
            <div className="flex mx-2 ">
              <div className="w-1/6 flex justify-center">
                <img
                  src={
                    currentStation?.image
                      ? currentStation?.image
                      : PlaceHolderLogo
                  }
                  alt={currentStation?.name}
                  className="h-24"
                />
              </div>
              <div className="w-2/6 my-2">
                <h3 className="text-gray-800 text-xl font-bold font-sans">
                  {currentStation?.name}
                </h3>
                <p className="text-gray-800 text-base  font-sans">
                  {currentStation?.description}
                </p>
                <h6 className="text-gray-800 text-base font-bold font-sans">
                  {currentStation?.location}
                </h6>
              </div>
              <div className="w-2/6 my-2">
                <h6 className="text-gray-800 text-base font-bold font-sans">
                  {t('dashboard.stationMap')}
                </h6>
                <iframe
                  src={
                    'https://www.google.com/maps/embed/v1/place?key=AIzaSyCW6HXYlqqnvyEVcgjXfdFVZvHxz7l-btQ&q=' +
                    currentStation?.location +
                    '&region=th&language=th'
                  }
                  width="380"
                  height="200"
                  allowfullscreen=""
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>
        </Collapse>

        {_.map(_.chunk(Sg, 24), (e) => {
          return (
            <div className="p-4 w-full font-sans">
              <DashboardMonitorComponentSlide
                currentStation={e}
                station={currentStation}
                handleEditUserFavorite={handleEditUserFavorite}
                user={me}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
